/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useEffect, useState, useMemo } from 'react';
import { Button } from '@carbon/react';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Invoker from '../utils/invoker';
import Copier from './Copier';
import { getOauthErrorMessage } from '../utils/error-message-handler';
import CodeViewer from './CodeViewer';

function TestToolOidcDiscovery({ config, onClick }) {
  const invoker = useMemo(() => new Invoker(), []);
  const [discovery, setDiscovery] = useState({});
  const [authError, setAuthError] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    setDiscovery(config.discovery);
  }, [config.discovery]);
  const discover = async () => {
    const { openIdConnectUrl } = config.flags;

    let discovery = {};
    try {
      setAuthError({});
      discovery = await invoker.discover(openIdConnectUrl);
    } catch (err) {
      console.error(err.stack);
      setAuthError(await getOauthErrorMessage(err, t));
    } finally {
      setDiscovery(discovery);
      if (onClick && typeof onClick === 'function') {
        onClick(discovery);
      }
    }
  };

  return (
    <div className="testToolOauth">
      <div className="url openIdConnectUrl">
        <legend htmlFor="openIdConnectUrl" className="parameterName">
          {t('explorer_openIdConnect_url')}
        </legend>
        <p className="parameterValue">{config.flags.openIdConnectUrl}</p>
      </div>
      <div className="refreshToken">
        <Button className="oidcDiscoverButton" id="oidcDiscoverButton" onClick={discover}>
          {t('explorer_oidc_discover')}
        </Button>
        {authError && authError.highlightedText && (
          <div className="authError">
            <pre>
              <code className="boundedSection hljs oauthError" dangerouslySetInnerHTML={authError.highlightedText} />
            </pre>
          </div>
        )}
      </div>
      {!isEmpty(discovery) && (
        <div>
          <div className="testResponseBody">
            <div className="body">
              <Copier element=".testResponseContent" />
              <div className={classNames('boundedSection testResponseContent')}>
                <div className="contrast responseDetails responseBody">
                  <CodeViewer codeLanguage="json">{JSON.stringify(discovery, null, 2)}</CodeViewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default TestToolOidcDiscovery;
